import Navbar from "./components/Navbar";
import FeatureHero from "./components/FeatureHero";
import FlashStream from "./components/FlashStream";
import HotRank from "./components/HotRank";
import GuideSection from "./components/GuideSection";
import ScenarioSection from "./components/ScenarioSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <FeatureHero />
        <FlashStream />
        <HotRank />
        <GuideSection />
        <ScenarioSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}